import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { SectionHeading, Reveal } from "@/components/Primitives";
import api from "@/lib/api";
import { ArrowRight, Check } from "lucide-react";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/public/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <SectionHeading eyebrow="Services" title="Everything your business needs online"
        subtitle="From a first website to a full e-commerce store — expand any service to learn more and send an enquiry." />
      <div className="max-w-4xl mx-auto">
        <Accordion type="single" collapsible className="space-y-3" data-testid="services-accordion">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.03}>
              <AccordionItem value={s.id} className="glass rounded-2xl border-white/10 px-5">
                <AccordionTrigger data-testid={`service-trigger-${s.slug}`} className="text-white hover:no-underline py-5">
                  <span className="flex items-center gap-3 text-left">
                    <span className="font-mono text-xs text-violet-400">{String(i + 1).padStart(2, "0")}</span>
                    <span className="font-semibold">{s.title}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 pb-5">
                  <p className="mb-4 leading-relaxed">{s.description}</p>
                  <Link to={`/contact?service=${encodeURIComponent(s.title)}`}>
                    <Button data-testid={`service-enquire-${s.slug}`} size="sm" className="bg-violet-600 hover:bg-violet-500 text-white">
                      Enquire about this <ArrowRight className="w-3.5 h-3.5 ml-1.5" />
                    </Button>
                  </Link>
                </AccordionContent>
              </AccordionItem>
            </Reveal>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
